var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87109 0.898438C4.19922 0.542969 4.77344 0.542969 5.10156 0.898438L8.60156 4.39844C8.84766 4.64453 8.92969 5.02734 8.79297 5.35547C8.65625 5.68359 8.35547 5.90234 8 5.90234H1C0.644531 5.90234 0.316406 5.68359 0.179688 5.35547C0.0429688 5.02734 0.125 4.64453 0.371094 4.39844L3.87109 0.898438ZM3.87109 12.6289L0.371094 9.12891C0.125 8.88281 0.0429688 8.5 0.179688 8.17188C0.316406 7.84375 0.644531 7.625 1 7.625H8C8.32812 7.625 8.65625 7.84375 8.79297 8.17188C8.92969 8.5 8.84766 8.88281 8.60156 9.12891L5.10156 12.6289C4.77344 12.9844 4.19922 12.9844 3.87109 12.6289Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDown);
export default __webpack_public_path__ + "static/media/up_down.2c507260d422c5a5efbe576ca7e3fcaf.svg";
export { ForwardRef as ReactComponent };